"use strict";
class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    constructor(initialState){
        this.board = initialState ? initialState.map((row)=>[
                ...row
            ]) : Array.from({
            length: 4
        }, ()=>Array(4).fill(0));
        this.score = 0;
        this.status = "idle";
    }
    isPlaying() {
        return this.status === "playing";
    }
    processRow(row) {
        const newRow = row.filter((num)=>num !== 0);
        const result = [];
        for(let i = 0; i < newRow.length; i++)if (newRow[i] === newRow[i + 1]) {
            const mergedValue = newRow[i] * 2;
            result.push(mergedValue);
            i += 1;
            this.score += mergedValue;
        } else result.push(newRow[i]);
        while(result.length < 4)result.push(0);
        return result;
    }
    checkWin() {
        if (this.board.some((row)=>row.includes(2048))) this.status = "win";
    }
    checkLose() {
        const hasEmpty = this.board.some((row)=>row.includes(0));
        if (hasEmpty) return;
        for(let row = 0; row < 4; row++)for(let col = 0; col < 4; col++){
            const current = this.board[row][col];
            if (col < 3 && current === this.board[row][col + 1]) return;
            if (row < 3 && current === this.board[row + 1][col]) return;
        }
        this.status = "lose";
    }
    applyMove(newBoard) {
        const changed = JSON.stringify(newBoard) !== JSON.stringify(this.board);
        if (!changed) return;
        this.board = newBoard;
        this.addRandomTile();
        this.checkWin();
        this.checkLose();
    }
    moveLeft() {
        if (!this.isPlaying()) return;
        const newBoard = this.board.map((row)=>this.processRow(row));
        this.applyMove(newBoard);
    }
    moveRight() {
        if (!this.isPlaying()) return;
        const newBoard = this.board.map((row)=>{
            const reversed = [
                ...row
            ].reverse();
            return this.processRow(reversed).reverse();
        });
        this.applyMove(newBoard);
    }
    transpose(matrix) {
        const result = [];
        for(let col = 0; col < 4; col++){
            result[col] = [];
            for(let row = 0; row < 4; row++)result[col][row] = matrix[row][col];
        }
        return result;
    }
    moveUp() {
        if (!this.isPlaying()) return;
        const transposed = this.transpose(this.board);
        const moved = transposed.map((row)=>this.processRow(row));
        this.applyMove(this.transpose(moved));
    }
    moveDown() {
        if (!this.isPlaying()) return;
        const transposed = this.transpose(this.board);
        const moved = transposed.map((row)=>{
            const reversed = [
                ...row
            ].reverse();
            return this.processRow(reversed).reverse();
        });
        this.applyMove(this.transpose(moved));
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board.map((row)=>[
                ...row
            ]);
    }
    getStatus() {
        return this.status;
    }
    addRandomTile() {
        const empty = [];
        for(let r = 0; r < 4; r++){
            for(let c = 0; c < 4; c++)if (this.board[r][c] === 0) empty.push({
                r: r,
                c: c
            });
        }
        if (!empty.length) return;
        const { r: r, c: c } = empty[Math.floor(Math.random() * empty.length)];
        this.board[r][c] = Math.random() < 0.9 ? 2 : 4;
    }
    start() {
        this.board = Array.from({
            length: 4
        }, ()=>Array(4).fill(0));
        this.score = 0;
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    restart() {
        this.start();
    }
}


"use strict";
const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$score = document.querySelector(".game-score");
const $09e991522ca7e64e$var$bestScoreEl = document.querySelector(".best-score");
const $09e991522ca7e64e$var$button = document.querySelector(".start");
function $09e991522ca7e64e$var$getBest() {
    return Number(localStorage.getItem("bestScore")) || 0;
}
function $09e991522ca7e64e$var$setBest(value) {
    localStorage.setItem("bestScore", value);
}
function $09e991522ca7e64e$var$render(prevState = null) {
    const state = $09e991522ca7e64e$var$game.getState();
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$bestScoreEl.textContent = $09e991522ca7e64e$var$getBest();
    $09e991522ca7e64e$var$cells.forEach((cell, index)=>{
        const r = Math.floor(index / 4);
        const c = index % 4;
        const value = state[r][c];
        const prevValue = prevState?.[r]?.[c] ?? 0;
        cell.textContent = value || "";
        cell.className = "field-cell";
        if (value) cell.classList.add(`field-cell--${value}`);
        if (prevValue === 0 && value) cell.classList.add("new");
        if (value && value === prevValue * 2) cell.classList.add("merge");
        setTimeout(()=>{
            cell.classList.remove("new", "merge");
        }, 200);
    });
    $09e991522ca7e64e$var$updateMessage();
}
function $09e991522ca7e64e$var$updateMessage() {
    const status = $09e991522ca7e64e$var$game.getStatus();
    document.querySelector(".message-start").classList.add("hidden");
    document.querySelector(".message-win").classList.add("hidden");
    document.querySelector(".message-lose").classList.add("hidden");
    if (status === "idle") document.querySelector(".message-start").classList.remove("hidden");
    if (status === "win") document.querySelector(".message-win").classList.remove("hidden");
    if (status === "lose") document.querySelector(".message-lose").classList.remove("hidden");
    if (status !== "idle") {
        $09e991522ca7e64e$var$button.textContent = "Restart";
        $09e991522ca7e64e$var$button.classList.remove("start");
        $09e991522ca7e64e$var$button.classList.add("restart");
    }
}
function $09e991522ca7e64e$var$handleMove(fn) {
    const prev = $09e991522ca7e64e$var$game.getState();
    fn();
    $09e991522ca7e64e$var$render(prev);
    $09e991522ca7e64e$var$updateBest();
}
function $09e991522ca7e64e$var$updateBest() {
    const best = $09e991522ca7e64e$var$getBest();
    const current = $09e991522ca7e64e$var$game.getScore();
    if (current > best) {
        $09e991522ca7e64e$var$setBest(current);
        $09e991522ca7e64e$var$bestScoreEl.textContent = current;
    }
}
/* START / RESTART */ $09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") $09e991522ca7e64e$var$game.start();
    else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$render();
    $09e991522ca7e64e$var$updateBest();
});
/* KEYBOARD */ document.addEventListener("keydown", (e)=>{
    const actions = {
        ArrowLeft: ()=>$09e991522ca7e64e$var$handleMove(()=>$09e991522ca7e64e$var$game.moveLeft()),
        ArrowRight: ()=>$09e991522ca7e64e$var$handleMove(()=>$09e991522ca7e64e$var$game.moveRight()),
        ArrowUp: ()=>$09e991522ca7e64e$var$handleMove(()=>$09e991522ca7e64e$var$game.moveUp()),
        ArrowDown: ()=>$09e991522ca7e64e$var$handleMove(()=>$09e991522ca7e64e$var$game.moveDown())
    };
    if (actions[e.key]) actions[e.key]();
});
/* INITIAL */ $09e991522ca7e64e$var$render();
$09e991522ca7e64e$var$bestScoreEl.textContent = $09e991522ca7e64e$var$getBest();


//# sourceMappingURL=index.90eea350.js.map
